import { apiV2 } from "./apiV2"

const locationsApi = apiV2.injectEndpoints({
  endpoints: (builder) => ({
    getLocations: builder.query({
      query: () => "interfester/locations",
      providesTags: ["Locations"],
    }),
  }),
})

export const { useGetLocationsQuery } = locationsApi
